import { Box, CTABlock } from '@ads-core/components';
import Image from 'next/image';

export const CTAFallBack = () => {
  return (
    <>
      <CTABlock.NotificationArrow arrowColor="containerPrimary" />
      <Box
        width="100%"
        height={{ initial: '358px', md: '100%' }}
        overflow="hidden"
        bg="containerLight"
        padding={5}
      >
        <Box position="relative" width="100%" height="100%">
          <CTABlock.Image objectFit="contain">
            <Image src="/assets/Liander_Regio_Blauw.png" alt="" fill />
          </CTABlock.Image>
        </Box>
      </Box>
    </>
  );
};
